import React, { createContext, useContext, useState, useEffect } from 'react';

const QuoteCartContext = createContext();

export function QuoteCartProvider({ children }) {
  const [items, setItems] = useState(() => {
    const saved = localStorage.getItem('quote_cart');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('quote_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (product, options = {}) => {
    const newItem = {
      id: `${product.product_id}_${Date.now()}`,
      product_id: product.product_id,
      product_name: product.name_fr,
      product_name_en: product.name_en,
      product_slug: product.slug,
      product_image: product.images?.[0],
      variant_id: options.variant_id || null,
      variant_name: options.variant_name || null,
      quantity: options.quantity || 1,
      nfc_option: options.nfc_option || null,
      printing_option: options.printing_option || null,
      notes: options.notes || ''
    };
    
    setItems(prev => [...prev, newItem]);
  };

  const removeItem = (itemId) => {
    setItems(prev => prev.filter(item => item.id !== itemId));
  };

  const updateItem = (itemId, updates) => {
    setItems(prev => prev.map(item => 
      item.id === itemId ? { ...item, ...updates } : item
    ));
  };

  const clearCart = () => {
    setItems([]);
  };

  const itemCount = items.length;

  return (
    <QuoteCartContext.Provider value={{
      items,
      addItem,
      removeItem,
      updateItem,
      clearCart,
      itemCount
    }}>
      {children}
    </QuoteCartContext.Provider>
  );
}

export function useQuoteCart() {
  const context = useContext(QuoteCartContext);
  if (!context) {
    throw new Error('useQuoteCart must be used within a QuoteCartProvider');
  }
  return context;
}

export default QuoteCartContext;
